import { Notes } from '@mui/icons-material';
import React from 'react';

import { processTaskDescription } from '../../utils/processTaskDescription';

import s from './TaskDescription.module.scss';

type TaskDescriptionProps = {
  description: string;
};

export const TaskDescription: React.FC<TaskDescriptionProps> = ({ description }) => {
  const processedHtml = processTaskDescription(description);

  return (
    <>
      <div className={s.title}>
        <Notes />
        <span>Описание задачи</span>
      </div>
      <div
        className={s.value}
        dangerouslySetInnerHTML={{
          __html: processedHtml,
        }}
      />
    </>
  );
};
